Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Tab2129526944",
  {"root":"Tab2129526944--root","focusIndicatorWrapper":"Tab2129526944--focusIndicatorWrapper","focusIndicator":"Tab2129526944--focusIndicator","activeIndicatorColor":"color-8","focusIndicatorColor":"color-8"},
  "",
  1,
  "Tab2129526944"
);

